class ShopSelector extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      const selectedValue = this.querySelector('select').value;
      if (Shopify.designMode) {
        alert('You are in the editor, so the form will not submit.');
        return;
      }
      window.location.href = selectedValue;
    });
  }
}

customElements.define('shop-selector', ShopSelector);
